export default __webpack_public_path__ + "media/chess.eff91f78.jpg";